import axios from 'axios';
import apiLogger from './apiLogger';
import network_contants from './network_contants';
import { authService } from '../services/authService';
import { toast } from 'react-toastify';
import { logger } from '../utils/logger';

export const axios_adapter = axios.create({
    baseURL: network_contants.CLIENT_API_BASE_URL,
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
    },
});

const isTournamentLeaderboardRequest = (config) => {
    if (config?.skipAuth) return true;
    const url = `${config?.baseURL || ''}${config?.url || ''}`;
    return url.includes('/rf/tournament/') && url.includes('/leaderboard');
};

const setRequestHeader = (headers, name, value) => {
    if (!headers) return;
    if (typeof headers.set === 'function') {
        headers.set(name, value);
        return;
    }
    headers[name] = value;
};

const deleteRequestHeader = (headers, name) => {
    if (!headers) return;
    if (typeof headers.delete === 'function') {
        headers.delete(name);
        return;
    }
    delete headers[name];
    delete headers[name.toLowerCase()];
};

axios_adapter.interceptors.request.use(
    async (config) => {
        if (isTournamentLeaderboardRequest(config)) {
            deleteRequestHeader(config.headers, 'Authorization');
            setRequestHeader(config.headers, 'x-analytics-key', 'nexintain');
            return apiLogger.request(config);
        }

        const token = await authService.getAuthTokens();
        //logger.log("API Header Token : ", token?.accessToken);
        if (token) {
            setRequestHeader(config.headers, 'Authorization', `Bearer ${token?.accessToken}`);
        }

        // Let the browser set multipart boundary. A JSON default Content-Type
        // would stringify File objects and the waiting-lobby upload would fail.
        if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
            deleteRequestHeader(config.headers, 'Content-Type');
            if (!config.timeout || config.timeout < 180000) {
                config.timeout = 180000;
            }
        }

        return apiLogger.request(config);
    },
    (error) => {
        return apiLogger.error(error);
    }
);

axios_adapter.interceptors.response.use(
    (response) => {
        //logger.log("API Response status : ", response?.status);
        if (response?.data?.error && response?.status !== 200 && response?.status !== 201) {
            return apiLogger.response(response?.data?.error);
        }
        else if (response?.data) {
            return apiLogger.response(response);
        }
        else {
            return apiLogger.response(response);
        }
    },
    (error) => {
        logger.log("API Response Error Status : ", error?.response?.status);
        if (error?.response?.data && error?.response?.status !== 502) {
            return apiLogger.response(error?.response?.data);
        }
        else {
            //logger.log("API Response Error: ", error?.response?.data);
            toast.error(`Something went wrong! Please try again later. STATUS CODE: ${error?.response?.status || 'NETWORK_ERROR'}`);
            return apiLogger.error(error);
        }
    }
);